import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "love-it-custom-sort",
    templateUrl: "./custom-sort.component.html",
    styleUrls: ["./custom-sort.component.scss"],
    standalone: false
})
export class CustomSortComponent implements OnInit {
  @Input() sortDir: "ASC" | "DESC";
  @Input() sortCol: string;
  @Input() column: string;
  @Input() name: string;
  @Output() sort: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  clicked() {
    this.sort.emit(this.column);
  }
}
